// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12436(3947648ad7)-C18/06/2026-17:45:05-B18/06/2026-17:48:44' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12436(3947648ad7)-C18/06/2026-17:45:05-B18/06/2026-17:48:44",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12436",
  shortHash: "3947648ad7",
  longHash: "3947648ad737f55a2cac6778ff67687f5eb0bce3",
  dateCommit: "18/06/2026-17:45:05",
  dateBuild: "18/06/2026-17:48:44",
  buildType: "Ansible",
  } ;
